import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function MobileOnboardingCarousel({ onComplete, onSkip }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const slides = [
    {
      icon: '🏐',
      title: 'Welcome to VballStat!',
      description: 'Track your volleyball stats on any device and see your improvement over time.',
      color: '#2E5AAC'
    },
    {
      icon: '👤',
      title: 'Add Players',
      description: 'Start by adding yourself or your team members to begin tracking performance.',
      color: '#4F5BA9'
    },
    {
      icon: '📅',
      title: 'Create Seasons',
      description: 'Organize your stats by season to track year-over-year growth.',
      color: '#2D8659'
    },
    {
      icon: '📊',
      title: 'Record Matches',
      description: 'Track detailed stats during or after your games with our easy-to-use interface.',
      color: '#D97706'
    },
    {
      icon: '📈',
      title: 'View Trends',
      description: 'Analyze your performance with detailed charts and insights.',
      color: '#2E5AAC'
    }
  ];

  const handleNext = () => {
    if (activeIndex < slides.length - 1) {
      swiperInstance?.slideNext();
    } else {
      onComplete();
    }
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'var(--bg)',
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Skip button */}
      <div style={{
        padding: '16px',
        textAlign: 'right'
      }}>
        <button
          onClick={onSkip}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--muted)',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            padding: '8px 16px'
          }}
        >
          Skip
        </button>
      </div>

      {/* Carousel */}
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={{
          clickable: true,
          bulletActiveClass: 'swiper-pagination-bullet-active',
          renderBullet: (index, className) => {
            return `<span class="${className}" style="background: ${slides[index].color}"></span>`;
          }
        }}
        onSwiper={setSwiperInstance}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        style={{ flex: 1, width: '100%' }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 32px',
              textAlign: 'center'
            }}>
              {/* Icon */}
              <div style={{
                fontSize: '80px',
                marginBottom: '32px',
                filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.1))'
              }}>
                {slide.icon}
              </div>

              {/* Title */}
              <h2 style={{
                fontSize: '28px',
                fontWeight: '700',
                margin: '0 0 16px 0',
                color: slide.color,
                letterSpacing: '-0.02em'
              }}>
                {slide.title}
              </h2>

              {/* Description */}
              <p style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: 'var(--muted)',
                margin: 0,
                maxWidth: '320px'
              }}>
                {slide.description}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Bottom navigation */}
      <div style={{
        padding: '24px 32px 40px',
        display: 'flex',
        gap: '12px'
      }}>
        {activeIndex > 0 && (
          <button
            onClick={() => swiperInstance?.slidePrev()}
            className="btn btn-muted"
            style={{ flex: 1 }}
          >
            Back
          </button>
        )}
        <button
          onClick={handleNext}
          className="btn btn-primary"
          style={{ flex: 2 }}
        >
          {activeIndex === slides.length - 1 ? "Get Started" : "Next"}
        </button>
      </div>

      <style>{`
        .swiper-pagination {
          position: relative !important;
          margin-top: 24px;
        }
        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          opacity: 0.3;
          transition: all 0.3s ease;
        }
        .swiper-pagination-bullet-active {
          opacity: 1;
          width: 24px;
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
}
